module.exports = __webpack_public_path__ + "img/convertibility-s.4f4582a2.png";